import Backbone from 'backbone';
import tmpl from '@bingads-webui-campaign-legacy/auto-targets/template/create/specificWebpageWithoutPreview.pug';
import SpecificTargetView from '@bingads-webui-campaign-legacy/auto-targets/view/specific-target';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
  }
  get events() {
    return {
      'click .addall-button': 'selectTarget',
    };
  }
  render() {
    this.$el.html(tmpl({
      i18n,
      containerTitle: this.options.isExclude ? i18n.get('DSA_Target_SpecificWebPage_Container_Title_Exclude') : i18n.get('DSA_Target_SpecificWebPage_Container_Title'),
    }));
    this.specificTarget = new SpecificTargetView({
      el: this.$('.conditions'),
      setting: this.options.setting,
      isShowUrlOnly: this.options.isShowUrlOnly,
    }).render();
    this.on('update:setting', (setting) => {
      this.specificTarget.trigger('update:setting', setting);
    });
    return this;
  }
  show() {
    this.$el.show();
    return this;
  }
  hide() {
    this.$el.hide();
    return this;
  }
  selectTarget() {
    this.trigger('selectTarget', {
      conditions: this.specificTarget.viewmodel.items(),
      type: 'specificpage',
      shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
    });
  }
  reset() {
    this.specificTarget.viewmodel.reset();
  }
}
